module.exports = __webpack_public_path__ + "img/completed-checklist.66baf44b.svg";